<template>
	<div>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout wrap>
					<v-flex xs12>
						<role-access-module-list
							:columns="columns"
							:check-all="checkAll"														
							:rows="table.rows"
							:last-page="table.lastPage"
							@all-is-selected="allIsSelected"
							@on-search="onSearch"
							@row-is-selected="rowIsSelected" />
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading ="disabled"
						:on-run-service="loading"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					/>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import roleAccessModuleList from './role-access-module-list';

async function created() {
	if (this.isSelected === 1) {
		this.params.isSelected = this.isSelected;
	}
	this.params.codeApp = this.codeApp;
	this.params.roleId = this.roleId;
	this.loadData(`project/${this.codeProject}/company/${this.codeCompany}/modules`);
}

function disabled() {
	return !this.table.rows.some(element => element.isSelected) || this.loading;
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.table.rows = this.selectIsRow(this.table.rows, 'isSelected', false, checked);
}

function closeModal() {
	this.$emit('close-modal');
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function rowIsSelected(row) {
	this.table.rows = this.selectIsRow(this.table.rows, 'isSelected', row);
	this.checkAll = this.every(this.table.rows);
}

function submitForm() {
	this.closeModal();
	this.modulesSelected = this.table.rows.filter(element => element.isSelected);
	this.$emit('save-selection', this.modulesSelected);
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Nombre', checked: true, visible: true },
		],
		checkAll: false,
		modulesSelected: [],
	};
}

export default {
	name: 'role-access-module-form',
	components: {
		roleAccessModuleList,
	},
	computed: {
		disabled,
	},
	created,
	data,
	methods: {
		allIsSelected,
		closeModal,
		onSearch,
		rowIsSelected,
		submitForm,
	},
	props: {
		codeApp: {
			type: String,
		},
		codeCompany: {
			type: String,
		},
		isSelected: {
			type: Number,
		},
		loading: {
			default: false,
			type: Boolean,
		},
		roleName: {
			type: String,
		},
		roleId: {
			type: [Number, String],
		},
		codeProject: {
			type: String,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/roles/role-access-module-form.vue